import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ReactElement } from 'react';

type DialogTitleComponentProps = {
  title: string;
  titleIcon?: ReactElement;
  onDialogClose: () => void;
};

const DialogTitleComponent = ({ title, titleIcon, onDialogClose }: DialogTitleComponentProps): ReactElement => (
  <DialogTitle>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      {titleIcon && titleIcon}
      <Box component="span">{title}</Box>
      <IconButton onClick={onDialogClose}>
        <CloseIcon />
      </IconButton>
    </Stack>
  </DialogTitle>
);

export default DialogTitleComponent;
